export default "__VITE_ASSET__KuqJvYKS__"